import React from 'react'
import { useStaticQuery, graphql, navigate, Link } from "gatsby"
import Img from "gatsby-image"
import CookieConsent from "react-cookie-consent"

/** @jsx jsx */
import { jsx, Container, Flex } from 'theme-ui'

import Logo from "./logo"
import Menu from "./menu"
import Footer from "./footer"
// import { MdFlashOn } from "react-icons/md"

const Layout = ({ads, children}) => {
    const data = useStaticQuery(
        graphql`
          query {
            site {
              siteMetadata {
                siteTitle
              }
            }
            allPrismicGeozone {
                edges {
                  node {
                    uid
                    data {
                      name
                    }
                  }
                }
            }
          }
        `
    )

    const logo = data.site.siteMetadata.siteTitle.split(' ')
    const zones = data.allPrismicGeozone.edges.map( ({ node }) => ({id: node.uid, name: node.data.name }) )

    return (
        <React.Fragment>
          {/* <Script id="axeptio">
            {`window.axeptioSettings= {
                clientId:"63170ea7531da232311d9778",
              };
              (function(d,s) {
                var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
                e.async = true; e.src = "//static.axept.io/sdk.js";
                t.parentNode.insertBefore(e, t);
              })(document, "script");
            `}
          </Script> */}

          <div sx={{
            position: "fixed",
            bottom: "0",
            left: "0",
            padding: "0 10px 10px",
            zIndex: "2000",
            ".cookie-banner": {
              backgroundColor: "rgba(255, 255, 255, .88)",
              color: "black",
              width: "100%",
              maxWidth: "500px",
              padding: "20px",
              borderRadius: "5px",
            },
            ".cookie-banner__btn": {
              marginTop: "10px",
              backgroundColor: "limegreen",
              border: "1px solid limegreen",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "5px",
              fontWeight: "700",
              cursor: "pointer",
              "&.cookie--decline": {
                marginLeft: "10px",
                backgroundColor: "transparent",
                color: "black",
                border: "1px solid grey",
                fontWeight: "400",
              }
            },
            "a": {
              color: "black"
            }
          }}>
            <CookieConsent
              location="bottom"
              buttonText="J'accepte"
              declineButtonText	="Je m'en vais"
              enableDeclineButton
              flipButtons
              onDecline={() => {
                navigate("http://ecosia.org")
              }}
              disableStyles={true}
              containerClasses="cookie-banner"
              buttonClasses="cookie-banner__btn"
              declineButtonClasses="cookie-banner__btn cookie--decline"
              contentClasses="cookie-banner__text"
            >
              <span>🍪</span> En utilisant ce site, vous acceptez que nous utilisions des cookies pour améliorer l'expérience utilisateur.ice, publicitaires et les besoins statistiques - selon notre <Link to="/politique-de-confidentialite">politique de confidentialité des données</Link>{" "}
            </CookieConsent>
          </div>

          <div sx={{
                  bg: 'muted',
                  pt: '20px',
                  pb: 4,
                  px: [2, 3, 4],
              }}
          >

            <Container>
              {ads && <div sx={{
                mt: "-20px",
                mb: "20px",
                maxWidth: '1000px',
                borderRadius: '0 0 10px 10px',
                overflow: "hidden",
                position: "relative"
              }}>
                  <div sx={{
                    position: 'absolute',
                    top: ['0', '0', '15%'],
                    left: '0',
                    height: ['100%', '100%', '70%'],
                    width: '30px',
                    backgroundColor: "#ebebeb",
                    zIndex: '4',
                    textAlign: 'center',
                    display: ['none', 'none', 'flex'],
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: "0 5px 5px 0"
                  }}>
                    <Link to={"/referencement"} 
                      css={{
                        rotate: "-90deg", 
                        textTransform: "uppercase",
                        fontSize: ['8px', '8px', '12px'], 
                        color: "#b6b6b6",
                        textDecoration: "none",
                        fontWeight: '700',
                        ':hover': {
                          color: "grey",
                        }
                      }}>
                        Publicité
                    </Link>
                  </div>
                  <a href={ads.banner1.url + "?utm_source=LocalGraph&utm_medium=cpc&utm_campaign=LocalClicks&utm_content=Top_Banner"} target="_blank">
                    <Img fluid={ads.banner1.img} />
                  </a>
                </div>}

              <Flex sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center', 
              }}>
                  <Logo logo={logo} />
                  <Menu zones={zones} />
              </Flex> 
            </Container>
      
            {children}
                
            <Container>
              <Footer />
            </Container>
          </div>
        </React.Fragment>
    )
}

export default Layout